import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import { ButtonGroup, Button } from 'react-bootstrap';
import { fullDate } from '../../../core/date';
import { displayBuyerBidState } from '../../../core/api';
import BidDetailModal from './BidDetailModal';
import BidHotelContacts from './BidHotelContacts';
import StyledGriddle from '../../../components/StyledGriddle';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';
import moment from 'moment-timezone';

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}

const dateDisplay = ({ value }) => {
  return (
    <span> {fullDate(value)} </span>
  )
}

class ProposalBidsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBid: false
    };
    this.expandComponent = this.expandComponent.bind(this);
    this.isExpandableRow = this.isExpandableRow.bind(this);
    this.expandColumnComponent = this.expandColumnComponent.bind(this);
  }
  
  
  findBid(id) {
    if (!this.props.proposal) {
      return {};
    }
    if (!this.props.proposal.bids) {
      return {};
    }
    const idx = this.props.proposal.bids.findIndex(findById, id);
    if (idx === -1) {
      console.log('Unable to find bid: ', id);
      return { id };
    }
    return this.props.proposal.bids[idx];
  }

  expandColumnComponent({ isExpandableRow, isExpanded }) {
    let content = '';

    if (isExpandableRow) {
      content = (<h3>
                  &nbsp;&nbsp;<i
                  className={isExpanded ? 'fa fa-minus-square' : 'fa fa-plus-square'}
                  aria-hidden="true"
                  />
              </h3>)
    } else {
      content = ' ';
    }
    return (
      <div> { content } </div>
    );
  }

  isExpandableRow(row) {
    return true
  }

  expandComponent(row) {
    const idx = this.props.proposal.bids.findIndex(findById, row.id);
    const bid = this.props.proposal.bids[idx];
    return (
      <BidHotelContacts
        proposal={this.props.proposal}
        bid={bid}
        addHotelContact={this.props.addHotelContact}
        handleContactData={this.props.handleContactData}
        HotelContactDelete={this.props.HotelContactDelete}
        HotelContactUpdate={this.props.HotelContactUpdate}
      />
    );
  }

  formatHotelDisplay = (row, rowIndex) => {  
    return (
    <span title={row}> {row} </span>
    )
 }
 
 formatDate = (row, rowIndex) => {
    const date = moment(row).format('MM/DD/YYYY');
    return (
    <span> {date} </span>
    )
 }

  render() {
    const bids = [];
    this.props.proposal.bids.forEach(bid => {
      let start
      let end
       this.props.proposal.tour.tour_stops.filter(item => {
        if(bid.bidset){
          if (item.place.name === bid.bidset.event.place.name) {
          
            return item.related_group_events.filter(itme2=>{
              if(itme2.group === bid.tourgroup_id && itme2.parent === bid.bidset.event.parent){
                start = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].lowest_check_in_date:itme2.start
                end = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].greatest_check_out_date:itme2.end
              }
            })
          }
          else{
            return null
          }
        }
      });
      
      const displayState = displayBuyerBidState(bid.buyer_state, bid.bidder_state);
      if (['Sent', 'Draft', 'Sending','Unsent'].includes(displayState) && (bid.bidset)) {
        bids.push({
          id: bid.id,
          name: bid.hotel.name,
          group: bid.bidset.event.group_name,
          location: `${bid.hotel.locality}, ${bid.hotel.region}`,
          distance: parseFloat(bid.distance_to_venue * 0.621371).toFixed(2),
          start:start?start:bid.bidset.event.start,
          end:end?end:bid.bidset.event.end,
          state: displayState,
        });
      }
    });

   const options = {
    expandBy: 'column'
    };
    
    return (
      <div id="proposalBidsTable">
        <BootstrapTable
        options={ options }
            data={bids}
            striped
            expandableRow={ this.isExpandableRow }
            expandComponent={ this.expandComponent }
            expandColumnOptions={ {
            expandColumnVisible: true,
            expandColumnComponent: this.expandColumnComponent,
            columnWidth: 50
        } }>
            <TableHeaderColumn dataField="id" isKey hidden headerAlign="center" dataAlign="center"></TableHeaderColumn>
            <TableHeaderColumn dataField="name" headerAlign="center" expandable={ false } dataAlign="center" dataFormat={this.formatHotelDisplay}>Hotel</TableHeaderColumn>
            <TableHeaderColumn dataField="group" headerAlign="center" expandable={ false } dataAlign="center" >Group</TableHeaderColumn>
            <TableHeaderColumn dataField="location" headerAlign="center" expandable={ false } dataAlign="center">Location</TableHeaderColumn>
            <TableHeaderColumn dataField="distance" headerAlign="center" expandable={ false } dataAlign="center">Distance</TableHeaderColumn>
            <TableHeaderColumn dataField="start" headerAlign="center" expandable={ false } dataAlign="center" dataFormat={this.formatDate}>Check In</TableHeaderColumn>
            <TableHeaderColumn dataField="end" headerAlign="center" expandable={ false } dataAlign="center" dataFormat={this.formatDate}>Check Out</TableHeaderColumn>
            <TableHeaderColumn dataField="state" headerAlign="center" expandable={ false } dataAlign="center">Status</TableHeaderColumn>
            </BootstrapTable>
      </div>
    );
  }
}

ProposalBidsTable.propTypes = {
  proposal: PropTypes.object.isRequired
};

ProposalBidsTable.defaultProps = {
  proposal: {
    bids: [],
  },
};
export default ProposalBidsTable;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalBidsTable.js